<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group label="انتخاب پلن مورد نظر" label-for="vip-plan-picker">
          <v-select
            @search="handleSearch"
            :disabled="isDisabled"
            id="vip-plan-picker"
            dir="rtl"
            :filterable="false"
            v-if="plansList"
            :reduce="(plan) => plan.id"
            v-model="selectedPlanId"
            :options="plansList"
            label="title"
            placeholder="پلن را انتخاب کنید"
          >
            <template #no-options>هیچ پلنی جهت نمایش وجود ندارد</template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["getPlanId"],
  props: {
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    selectedPlanId: {
      handler(val) {
        this.$emit("getPlanId", val);
      },
    },
  },
  mounted() {
    this.getAllVipPlans();
  },
  data() {
    return {
      plansList: null,
      selectedPlanId: null,
      searchVal: null,
      timeout: null,
    };
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllVipPlans();
        loadingFn(false);
      }, 300);
    },

    async getAllVipPlans() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllVipPlans = new GetAllVipPlans(_this);
        let qParams = {
          pageNumber: 1,
          count: 30,
        };
        if (_this.searchVal) {
          qParams["title"] = _this.searchVal;
        }
        getAllVipPlans.setRequestParamDataObj(qParams);
        await getAllVipPlans.fetch((res) => {
          _this.plansList = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllVipPlans } from "@/libs/Api/VipUser";
</script>
